// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__Cie6b","rotate":"loading_rotate__5bjh-"};